module.exports = __webpack_public_path__ + "img/Shiba-BG.7903ece0.jpg";